"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var DefaultButton_1 = require("../../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var backToFinanceButtonStyles_1 = require("./backToFinanceButtonStyles");
var BackToFinanceButton = function (_a) {
    var carConfigurationUrl = _a.carConfigurationUrl;
    var _b;
    var styles = backToFinanceButtonStyles_1.default();
    var navigateToFinanceConfiguration = function () { return (window.location.href = carConfigurationUrl); };
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    return (<DefaultButton_1.default onClick={navigateToFinanceConfiguration} className={[styles.buttonWrapper]} variant="outlined" dataTest={'checkout:finance_section:button'} disableTouchRipple={!!((_b = checkout4) === null || _b === void 0 ? void 0 : _b.disableTouchRipple)}>
      <Translation_1.default id={'trans__checkout__extras_page__finance_back_cta'} className={styles.buttonLabel}/>
    </DefaultButton_1.default>);
};
exports.default = BackToFinanceButton;
